var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnimonsEte(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127,
    height: 110,
    viewBox: "0 0 127 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_230",
    "data-name": "Groupe 230",
    transform: "translate(-0.156 5.336)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "l_\\xE9t\\xE9",
    "data-name": "l\\u2019\\xE9t\\xE9",
    transform: "translate(0.156 64.664)",
    fill: "#fff",
    fontSize: 56,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "l\u2019\xE9t\xE9")), /*#__PURE__*/React.createElement("text", {
    id: "Animons",
    transform: "translate(20.156 10.664)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Animons")), /*#__PURE__*/React.createElement("text", {
    id: "_2022",
    "data-name": 2022,
    transform: "translate(13.156 96.664)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    letterSpacing: "0.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2022")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimonsEte);
export default __webpack_public_path__ + "static/media/animons-ete.7bd3c9101f6e115b99facff0c90e826b.svg";
export { ForwardRef as ReactComponent };